<div id="programs" class="inner-page">
  <div class="container-fluid px-lg-5">

    <h2 class="title">Academic Programs</h2>
    <p class="inner-lead mt-3">
      Shah Satnam Ji Girls' College, Sirsa offers a wide range of Undergraduate and Postgraduate programmes affiliated
      to Chaudhary Devi Lal University (CDLU), Sirsa. The college is committed to providing quality education across
      arts, science and commerce streams.
    </p>

    <hr class="divider">

    <!-- UNDERGRADUATE (UG) PROGRAMS -->
    <h3 class="programs-section-title">UNDERGRADUATE (UG) PROGRAMS</h3>
    <div class="table-responsive-inner">
      <table class="programs-table">
        <thead>
          <tr>
            <th style="width: 8%;">SR.<br>NO.</th>
            <th style="width: 52%;">NAME OF THE PROGRAMME LEADING TO<br>DEGREE</th>
            <th style="width: 15%;">YEAR OF<br>INTRODUCTION</th>
            <th style="width: 13%;">DURATION</th>
            <th style="width: 12%;">INTAKE</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1</td>
            <td>B.A. (Bachelor of Arts)</td>
            <td>1997</td>
            <td>3 Years</td>
            <td>350</td>
          </tr>
          <tr>
            <td>2</td>
            <td>B.Com. (Bachelor of Commerce)</td>
            <td>1997</td>
            <td>3 Years</td>
            <td>90</td>
          </tr>
          <tr>
            <td>3</td>
            <td>B.Sc. (Bachelor of Science - Physical Sciences)</td>
            <td>2012</td>
            <td>3 Years</td>
            <td>90</td>
          </tr>
          <tr>
            <td>4</td>
            <td>B.C.A. (Bachelor of Computer Applications)</td>
            <td>1999</td>
            <td>3 Years</td>
            <td>80</td>
          </tr>
          <tr>
            <td>5</td>
            <td>B.B.A. (Bachelor of Business Administration)</td>
            <td>1998</td>
            <td>3 Years</td>
            <td>60</td>
          </tr>
          <tr>
            <td>6</td>
            <td>B.A.J.M.C. (Bachelor of Arts in Journalism and Mass Communication)</td>
            <td>2009</td>
            <td>3 Years</td>
            <td>60</td>
          </tr>
          <tr>
            <td>7</td>
            <td>B.P.Ed. (Bachelor of Physical Education)</td>
            <td>2006</td>
            <td>2 Years</td>
            <td>50</td>
          </tr>
          <tr>
            <td>8</td>
            <td>D.P.Ed. (Diploma in Physical Education)</td>
            <td>2007</td>
            <td>2 Years</td>
            <td>50</td>
          </tr>
          <tr>
            <td>9</td>
            <td>B.Sc. (Physical Health and Sports Education) <span class="badge-new">NEW</span></td>
            <td>2025</td>
            <td>4 Years</td>
            <td>40</td>
          </tr>
          <tr>
            <td>10</td>
            <td>B.P.A. (Bachelor of Performing Arts) <span class="badge-new">NEW</span></td>
            <td>2025</td>
            <td>3 Years</td>
            <td>40</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- POSTGRADUATE (PG) PROGRAMS -->
    <h3 class="programs-section-title">POSTGRADUATE (PG) PROGRAMS</h3>
    <div class="table-responsive-inner">
      <table class="programs-table">
        <thead>
          <tr>
            <th style="width: 8%;">SR.<br>NO.</th>
            <th style="width: 52%;">NAME OF THE PROGRAMME LEADING TO<br>DEGREE</th>
            <th style="width: 15%;">YEAR OF<br>INTRODUCTION</th>
            <th style="width: 13%;">DURATION</th>
            <th style="width: 12%;">INTAKE</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1</td>
            <td>M.A. (Master of Arts - English)</td>
            <td>2000</td>
            <td>2 Years</td>
            <td>30</td>
          </tr>
          <tr>
            <td>2</td>
            <td>M.A. (Master of Arts - Hindi)</td>
            <td>2000</td>
            <td>2 Years</td>
            <td>30</td>
          </tr>
          <tr>
            <td>3</td>
            <td>M.A. (Master of Arts - Public Administration)</td>
            <td>2003</td>
            <td>2 Years</td>
            <td>30</td>
          </tr>
          <tr>
            <td>4</td>
            <td>M.Sc. (Master of Science - Mathematics)</td>
            <td>2000</td>
            <td>2 Years</td>
            <td>30</td>
          </tr>
          <tr>
            <td>5</td>
            <td>M.Com. (Master of Commerce)</td>
            <td>2002</td>
            <td>2 Years</td>
            <td>30</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- BROCHURE DOWNLOAD SECTION -->
    <!-- <div class="mt-section text-center mb-5">
      <a href="/assets/pdf/academics/Programs.pdf" target="_blank" class="pdf-download-btn">
        <i class="fa fa-download"></i> Download Academic Programs Brochure
      </a>
    </div> -->

  </div>
</div>